// 11 canonical activity-purpose categories surfaced on Meeting / Follow-up /
// Activity dialogs. Mirrors backend `ACTIVITY_PURPOSES` constant in server.py.
// Drives admin reports — sales pulse can slice by purpose (e.g. "% time on
// demos vs internal meetings").
export const ACTIVITY_PURPOSES = [
  { key: "lead_prospecting",     label: "Lead / Prospecting" },
  { key: "lead_qualification",   label: "Lead Qualification" },
  { key: "demonstration",        label: "Demonstration" },
  { key: "follow_up",            label: "Follow-ups" },
  { key: "negotiation",          label: "Negotiations" },
  { key: "onsite_training",      label: "On-site Training" },
  { key: "technical_support",    label: "Technical Support" },
  { key: "onsite_service",       label: "Technical / On-site Services" },
  { key: "events_exhibition",    label: "Events / Exhibition / Conferences" },
  { key: "tech_orientation",     label: "Technology Orientation Program" },
  { key: "internal_meeting",     label: "Internal Meetings" },
  { key: "wfh_online_meeting",   label: "WFH Online Meetings" },
];

export const PURPOSE_LABEL = Object.fromEntries(ACTIVITY_PURPOSES.map((p) => [p.key, p.label]));
